import { commonViewTexts } from '../common';
import { trainingMessagesShared } from './shared/training-messages';

export const modelDetailViewTexts = {
  description: `${commonViewTexts.model}の詳細情報を表示しています。`,
  section1: {
    title: 'ラベル',
    labelIsUndefined: '未設定',
    goToLabelList: 'ラベル一覧に移動'
  },
  section2: {
    title: commonViewTexts.blueprintData,
    goToModelImageList: `${commonViewTexts.blueprintData}一覧に移動`
  },
  section3: {
    common: {
      title: commonViewTexts.model,
      trainButton: '学習する',
      retrainButton: '再学習する'
    },
    version: {
      title: `${commonViewTexts.model}のバージョン`,
      description: `過去のトレーニングで作成した${commonViewTexts.model}を利用する場合は、以下のリストから選択してください。星の数は${commonViewTexts.model}の精度を表しています。`
    }
  },
  messages: {
    annotationCompletedShort: `${commonViewTexts.blueprintData}のアノテーションが完了しました。学習を開始しましょう。`,
    annotationCompleted: trainingMessagesShared.annotationCompleted,
    annotationIncompleteShort:
      '学習を行うためにはすべてのデータにアノテーションを行う必要があります。',
    annotationInComplete: trainingMessagesShared.annotationIncomplete,
    modelIsAvailable: trainingMessagesShared.modelIsAvailable,
    noLabelRegistered: trainingMessagesShared.noLabelRegistered,
    trainingError: trainingMessagesShared.trainingError,
    trainingRunning: trainingMessagesShared.trainingRunning,
    trainingRunningShort: '現在学習中です。'
  },
  modelImageDataSummary: ({
    numImages,
    numAnnotated,
    training = false
  }: {
    numImages: number;
    numAnnotated: number;
    training?: boolean;
  }): string[] =>
    training
      ? [
          `${numImages}枚の${commonViewTexts.blueprintData}が登録されています。`,
          '現在学習中です。',
          `学習中は${commonViewTexts.blueprintData}の編集やアノテーションを行うことができません。`
        ]
      : numImages === 0
      ? [`${commonViewTexts.blueprintData}が登録されていません。`]
      : numAnnotated === numImages
      ? [
          `${numImages}枚の${commonViewTexts.blueprintData}が登録されています。`,
          'すべての画像のアノテーションが完了しました。'
        ]
      : [
          `${numImages}枚の${commonViewTexts.blueprintData}が登録されています。`,
          `${numImages - numAnnotated}枚の${
            commonViewTexts.blueprintData
          }がアノテーションされていません。`
        ]
} as const;
